import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import useSeo from "@/hooks/useSeo";
import useI18n from "@/i18n";
import { pagePath, SOIN_KEYS } from "@/i18n/config";

export default function NotFound() {
    const { t, lang, soins, toSoin } = useI18n();
    const page = t.pages.notfound;

    useSeo({
        title: t.seo.notfound.title,
        description: t.seo.notfound.description,
        path: pagePath(lang, "notfound"),
        lang,
        noindex: true,
    });

    return (
        <>
            <Header />
            <main className="pt-24" data-testid="not-found-page">
                <div className="mx-auto max-w-[840px] px-5 pb-24 pt-12">
                    <p className="eyebrow">{page.eyebrow}</p>
                    <h1 className="title-grad mt-4 text-4xl sm:text-5xl">{page.h1}</h1>
                    <hr className="rule-gold mt-5 w-24" />
                    <p className="mt-5 max-w-[56ch] text-lg text-ink2">{page.lead}</p>
                    <ul className="mt-6 space-y-2">
                        <li>
                            <Link
                                to={pagePath(lang, "home")}
                                className="link-underline font-semibold text-terrat"
                                data-testid="notfound-home-link"
                            >
                                {page.homeLink}
                            </Link>
                        </li>
                        {SOIN_KEYS.map((key) => (
                            <li key={key}>
                                <Link
                                    to={toSoin(key)}
                                    className="link-underline font-semibold text-terrat"
                                    data-testid={`notfound-link-${key}`}
                                >
                                    {soins[key].nav}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
            </main>
            <Footer />
        </>
    );
}
